import { cameraBannerProduct, carTracking1, enterpriseKit1, peopleTracking1, starterKit1 } from '@assets/images/main/camera';
import {
  productCardBleStarterM,
  productCardBleStarterD,
  productCardBleEnterpriseM,
  productCardBleEnterpriseD,
  productCardAoaStarterM,
  productCardAoaStarterD,
  productCardAoaEnterpriseM,
  productCardAoaEnterpriseD,
  productCardUwbStarterM,
  productCardUwbStarterD,
  productCardUwbEnterpriseM,
  productCardUwbEnterpriseD,
  productCardComfortM,
  productCardComfortD,
  productCardAiStarterM,
  productCardAiStarterD,
  productCardAiServerM,
  productCardAiServerD,
  productCardVehicleM,
  productCardVehicleD,
  productCardYardM,
  productCardYardD,
  productCardCameraM,
  productCardCameraD,
  productCardOutdoorM,
  productCardOutdoorD,
  productCardRtlsM,
  productCardRtlsD,
  productCardAccessM,
  productCardAccessD,
  productCardIotM,
  productCardIotD,
  productCardOrbroOsM,
} from '@assets/images/main/home/products/all';

import {
  aoaEnterpriseKit,
  aoaStarterKit,
  assetTracking1,
  bleEnterpriseKit,
  bleStarterKit,
  comfortKit1,
  uwbEnterpriseKit,
  uwbStarterKit,
  workerTracking1,
} from '@assets/images/main/rtls/product';
import { iotBannerProduct } from '@assets/images/main/sensor';

export default {
  assetPackage: {
    label: 'Assets Tracking Package',
    title: 'Gói định vị vị trí tài sản',
    product: 'TwinTrackerPro 10 + Server 1',
    desc: 'Sản phẩm hỗ trợ theo dõi vị trí theo thời gian thực bằng cách gắn thiết bị UWB lên công nhân hoặc trang bị, thiết bị thi công.',
    img: assetTracking1,
    link: '/vi/rtls',
    index: '1',
    productIndex: 1,
  },

  workerPackage: {
    label: 'Workers Tracking Package',
    title: 'Gói định vị vị trí công nhân',
    product: 'TwinTrackerPro 10 + Server 1',
    desc: 'Sản phẩm hỗ trợ theo dõi vị trí theo thời gian thực bằng cách gắn thiết bị UWB lên công nhân hoặc trang bị.',
    img: workerTracking1,
    link: '/rtls',
    index: '2',
    productIndex: 1,
  },

  carPackage: {
    label: 'Vehicle Location Tracking Package',
    title: 'Gói định vị vị trí phương tiện xe cộ',
    product: 'Server1 + NVR1 + PTZ Camera2',
    desc: 'Thông qua camera, hệ thống có thể phát hiện và quản lý vị trí cũng như các hành vi bất thường của nhiều đối tượng khác nhau như người, phương tiện, v.v.',
    img: carTracking1,
    link: '/vi/camera',
    index: '1',
    productIndex: 1,
  },

  peoplePackage: {
    label: 'People Tracking and Analysis Package',
    title: 'Gói định vị vị trí tài sản',
    product: 'Server1 + NVR1 + IP Camera4',
    desc: 'Thông qua camera, hệ thống có thể phân tích lộ trình di chuyển của người bên trong một khu vực nhất định và phát hiện các tình huống đột xuất hoặc sự cố bất ngờ.',
    img: peopleTracking1,
    link: '/vi/camera',
    index: '2',
    productIndex: 1,
  },

  recommand: 'Sản phẩm khuyến nghị',

  cards: [
    {
      title: 'TwinTracker BLE Starter Kit',
      desc: 'ORBRO Edge RTLS, L2 Switch, TwinTracker BLE (4 thiết bị)',
      link: '/rtls/ble',
      img: { desktop: productCardBleStarterD, tablet: productCardBleStarterM, mobile: productCardBleStarterM },
    },
    {
      title: 'BLE Enterprise Kit',
      desc: 'ORBRO Server, L2 Switch (2 thiết bị), ORBRO Edge RTLS (2 thiết bị), TwinTracker BLE (12 thiết bị)',
      link: '/rtls/ble',
      img: { desktop: productCardBleEnterpriseD, tablet: productCardBleEnterpriseM, mobile: productCardBleEnterpriseM },
    },
    {
      title: 'TwinTracker AoA Starter Kit',
      desc: 'ORBRO Edge RTLS, L2 Switch, TwinTracker AoA (4 thiết bị)',
      link: '/rtls/aoa',
      img: { desktop: productCardAoaStarterD, tablet: productCardAoaStarterM, mobile: productCardAoaStarterM },
    },
    {
      title: 'AoA Enterprise Kit',
      desc: 'ORBRO Server, L2 Switch (2 thiết bị), ORBRO Edge RTLS (2 thiết bị), TwinTracker AoA (12 thiết bị)',
      link: '/rtls/aoa',
      img: { desktop: productCardAoaEnterpriseD, tablet: productCardAoaEnterpriseM, mobile: productCardAoaEnterpriseM },
    },
    {
      title: 'TwinTracker UWB Starter Kit',
      desc: 'ORBRO Server, L2 Switch (2 thiết bị), ORBRO Edge RTLS (2 thiết bị), TwinTracker BLE (12 thiết bị)',
      link: '/rtls/uwb',
      img: { desktop: productCardUwbStarterD, tablet: productCardUwbStarterM, mobile: productCardUwbStarterM },
    },
    {
      title: 'UWB Enterprise Kit',
      desc: 'ORBRO Server, L2 Switch (2 thiết bị), ORBRO Edge RTLS (2 thiết bị), TwinTracker UWB (12 thiết bị)',
      link: '/rtls/uwb',
      img: { desktop: productCardUwbEnterpriseD, tablet: productCardUwbEnterpriseM, mobile: productCardUwbEnterpriseM },
    },
    {
      title: 'Comfort Kit',
      desc: 'Ứng dụng di động, Thẻ UWB (8 thẻ), Thẻ UWB',
      link: '/rtls/comfort',
      img: { desktop: productCardComfortD, tablet: productCardComfortM, mobile: productCardComfortM },
    },
    {
      title: 'ORBRO Edge AI Starter Kit',
      desc: 'ORBRO Edge AI, L2 Switch',
      link: '/camera/edge',
      img: { desktop: productCardAiStarterD, tablet: productCardAiStarterM, mobile: productCardAiStarterM },
    },
    {
      title: 'ORBRO AI Server Enterprise Kit',
      desc: 'Máy chủ ORBRO AI, ORBRO Server',
      link: '/camera/server',
      img: { desktop: productCardAiServerD, tablet: productCardAiServerM, mobile: productCardAiServerM },
    },
    {
      title: 'Vehicle Tracking Kit',
      desc: 'ORBRO Server x 1 + Thiết bị GPS x 5',
      link: '/outdoor/gps',
      img: { desktop: productCardVehicleD, tablet: productCardVehicleM, mobile: productCardVehicleM },
    },
    {
      title: 'Yard Tracking Kit',
      desc: 'ORBRO Server, Cổng LoRa, Thẻ GPS (10 thẻ)',
      link: '/outdoor/lora',
      img: { desktop: productCardYardD, tablet: productCardYardM, mobile: productCardYardM },
    },
    {
      title: 'Theo dõi video',
      desc: 'Theo dõi đối tượng bằng AI từ video',
      link: '/camera',
      img: { desktop: productCardCameraD, tablet: productCardCameraM, mobile: productCardCameraM },
    },
    {
      title: 'Theo dõi ngoài trời',
      desc: 'Theo dõi vị trí xe và bãi ngoài trời',
      link: '/outdoor',
      img: { desktop: productCardOutdoorD, tablet: productCardOutdoorM, mobile: productCardOutdoorM },
    },
    {
      title: 'Theo dõi vị trí bằng sóng',
      desc: 'Theo dõi vị trí dựa trên BLE, AoA, UWB và công nghệ không dây',
      link: '/rtls',
      img: { desktop: productCardRtlsD, tablet: productCardRtlsM, mobile: productCardRtlsM },
    },
    {
      title: 'Hệ thống kiểm soát ra vào',
      desc: 'Cửa tự động, nhận diện khuôn mặt và quản lý ra vào',
      link: '/access',
      img: { desktop: productCardAccessD, tablet: productCardAccessM, mobile: productCardAccessM },
    },
    {
      title: 'Industry IoT',
      desc: 'Tích hợp cảm biến chất lượng không khí, cảm biến CO, cổng LoRa, robot, v.v.',
      link: '/iot',
      img: { desktop: productCardIotD, tablet: productCardIotM, mobile: productCardIotM },
    },
    {
      type: 'orbroOs',
      title: 'ORBRO OS',
      desc: 'All Spaces, All Devices, Connected at a Glance on a Digital Platform',
      link: '/os',
      img: {
        desktop: productCardOrbroOsM,
        tablet: productCardOrbroOsM,
        mobile: productCardOrbroOsM,
      },
    },
  ],
};
